import styled from '@emotion/styled';
import { Color, RadioButton } from '@liveoptics/react-ui';
import React, { useCallback } from 'react';
import { OpportunityMode } from '../../../enums';
import { Opportunity } from '../../../interfaces';
import { OpportunitiesDropDownMenu, OpportunityModeDropDownMenu } from '../../menus';
import { SelectionOption } from './SelectionOption';

export interface OpportunitiesFoundSubFormProps {
  selectionOption: SelectionOption;
  opportunities: Opportunity[];
  defaultOpportunity?: number;
  defaultOpportunityMode?: OpportunityMode;
  onOpportunityModeChange: (opportunityMode: OpportunityMode) => void;
  onOpportunityIdChange: (opportunityId?: number) => void;
  onSelectionOptionChange: (selectionOption: SelectionOption) => void;
}

const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  label {
    max-width: 100%;
    width: 100%;
    height: 45px !important;
    ::after {
      top: unset !important;
    }
  }
`;

const RadioButtonTitle = styled.p`
  padding-left: 32px;
  margin-bottom: 8px !important;
  margin-top: 16px !important;
  text-align: left;
  font: normal normal normal 14px/17px Open Sans;
  letter-spacing: 0.28px;
  color: ${Color.coolGray700};
  opacity: 1;
`;

const NoOpportunityContainer = styled.div`
  margin-top: 16px !important;
`;

export const OpportunitiesFoundSubForm = (props: OpportunitiesFoundSubFormProps) => {
  const handleSelectionOptionChange = useCallback(
    (selectionOption: SelectionOption) => () => {
      props.onSelectionOptionChange(selectionOption);
    },
    [props]
  );

  const handleOpportunityModeChange = useCallback(
    (value: string) => props.onOpportunityModeChange?.(OpportunityMode[value]),
    [props]
  );

  const handleOpportunityIdChange = useCallback(
    (value: number) => props.onOpportunityIdChange?.(value),
    [props]
  );

  return (
    <CheckboxGroup>
      <div>
        <RadioButtonTitle>Select opportunity ID</RadioButtonTitle>
        <RadioButton
          id="opportunities"
          type="radio"
          name="opportunity-input-method-selection"
          checked={props.selectionOption === SelectionOption.Opportunities}
          onChange={handleSelectionOptionChange(SelectionOption.Opportunities)}
        />
        <label htmlFor="opportunities">
          <OpportunitiesDropDownMenu
            opportunities={props.opportunities}
            defaultValue={
              props.selectionOption === SelectionOption.Opportunities
                ? props.defaultOpportunity
                : undefined
            }
            disabled={props.selectionOption === SelectionOption.OpportunityMode}
            onChange={handleOpportunityIdChange}
          />
        </label>
      </div>
      <NoOpportunityContainer>
        <RadioButtonTitle>Activity not tied to opportunity</RadioButtonTitle>
        <RadioButton
          id="opportunity-mode"
          type="radio"
          name="opportunity-input-method-selection"
          checked={props.selectionOption === SelectionOption.OpportunityMode}
          onChange={handleSelectionOptionChange(SelectionOption.OpportunityMode)}
        />
        <label htmlFor="opportunity-mode">
          <OpportunityModeDropDownMenu
            disabled={props.selectionOption === SelectionOption.Opportunities}
            defaultValue={
              props.selectionOption === SelectionOption.OpportunityMode &&
              props.defaultOpportunityMode &&
              props.defaultOpportunityMode !== OpportunityMode.None &&
              props.defaultOpportunityMode !== OpportunityMode.Assigned
                ? props.defaultOpportunityMode
                : undefined
            }
            onChange={handleOpportunityModeChange}
          />
        </label>
      </NoOpportunityContainer>
    </CheckboxGroup>
  );
};
